import BaseModel from '../model/BaseModel';
import SeatGridService from '../service/movie-service'
import Seat from './Seat';
import ModelArray from './ModelArray';
import Collection from './Collection'

/**
 * Collection of movies with Methods to format the movies into usable objects.
 */
export class SeatGroups extends Collection {

    constructor(data) {
        super()
        this.data = new SeatGroup(data);
    }

    
}


/**
 * Single SeatGroup Object.
 */
export class SeatGroup extends BaseModel {

    constructor(data) {
        super(data);
        this.Size                       = data.Size;
        this.Active                     = data.Active;
        this.SeatType                   = data.SeatType;
        this.SeatData                   = data.SeatData;
        this.Selected                   = data.Selected;
        this.SeatsInGroup               = data.SeatsInGroup || [];
        this.ColumnIndex                = data.ColumnIndex;
        this.RowIndex                   = data.RowIndex;
        this.AreaNumber                 = data.AreaNumber;
        this.SelectedButNotChangeable   = data.SelectedButNotChangeable || false;
    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/SeatGroups.js